import moment from "moment";

/**
 * CartItem model
 *
 * @class CartItem
 */
export default class CartItem {
    constructor({
        id = "",
        cantidad = 0,
        Pax = null,
        ParkId = null,
        type = 1,
        BookId = null,
        IsOnlyHotel = false,
        TotalMedia = 0,
        Id = 0,
        date = "",
        Amount = 0,
        NormalIndividual = 0,
        RateKey = "",
        saleService = {},
        VisitDate = null,
        tags = [],
    } = {}) {
        this.id = id;
        this.cantidad = cantidad;
        this.Pax = Pax;
        this.ParkId = ParkId;
        this.type = type;
        this.BookId = BookId;
        this.IsOnlyHotel = IsOnlyHotel;
        this.TotalMedia = TotalMedia;
        this.Id = Id;
        this.date = date || moment().format("YYYY-MM-DD");
        this.Amount = Amount;
        this.NormalIndividual = NormalIndividual;
        this.RateKey = RateKey;
        this.saleService = saleService;

        // Campos que se añaden después del cálculo de precio
        this.VisitDate = VisitDate;
        this.tags = tags;
    }
}
